// Copyright (c) Docugami, Inc. All rights reserved.

import { useMemo } from "react";
import { useAppSelector } from "./redux";
import { QualityControlWarning } from "store/frontend/frontendSlice";
import { selectClusterId } from "store/reports/selectors";
import { selectQualityControlWarningsForFile } from "store/frontend/selectors";

export const useQualityControlWarning = (fileId: string, label?: string, spanId?: string): QualityControlWarning | undefined => {
    const clusterId = useAppSelector(selectClusterId);
    const warningId = useMemo(() => !!label && !!spanId ? `${label.toLowerCase()}|${spanId}` : !!label ? `${label.toLowerCase()}|null` : undefined, [label, spanId]);
    return useAppSelector(state => !!fileId && !!warningId ? selectQualityControlWarningsForFile(state, clusterId, fileId)?.(state)?.data?.entities[warningId] : undefined);
}
